import request from '@/utils/request'
import ENDPOINT from '@/config/endpoint'

export function getPlaceFacilityGroups(params) {
  return request({
    url: ENDPOINT.PLACE_FACILITY_GROUPS,
    method: 'get',
    params
  })
}

export function createPlaceFacilityGroup(data) {
  return request({
    url: ENDPOINT.PLACE_FACILITY_GROUPS,
    method: 'post',
    data
  })
}

export function updatePlaceFacilityGroup(data) {
  return request({
    url: ENDPOINT.PLACE_FACILITY_GROUPS,
    method: 'patch',
    data
  })
}

export function deletePlaceFacilityGroup(params) {
  return request({
    url: ENDPOINT.PLACE_FACILITY_GROUPS,
    method: 'delete',
    params: typeof params === 'object' ? params : { id: params }
  })
}
